import { useCallback } from 'react';
import { DropdownMenu } from 'components';
import { useDropdownOptions, useDropdownValue } from 'hooks';
import styles from 'modules/campaigns/modules/common-campaign-form/components/UserFrequencyCapping/UserFrequencyCapping.module.scss';
import { FREQUENCY } from 'modules/campaigns/modules/common-campaign-form/config';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';

export const FREQUENCY_TYPES = [
    { value: FREQUENCY.DAY, label: 'Day' },
    { value: FREQUENCY.WEEK, label: 'Week' },
    { value: FREQUENCY.MONTH, label: 'Month' },
];

const MSG_ID_PREFIX = 'video.campaign.editor.UserFrequencyCapping.option';

const dropDownStyle = {
    control: props => ({
        ...props,
        border: `1px solid ${styles.gray5}`,
    }),
};

export const FrequencyCappingDropDown = () => {
    const { value: frequencyCapping, onChange: onFrequencyCappingChange } = useFormFieldValue({
        field: 'campaignTargeting.userFrequencyCapping.frequency',
    });

    const { isMessageIdExists } = useIntl();
    const msgIdPrefix = isMessageIdExists(MSG_ID_PREFIX + frequencyCapping) ? MSG_ID_PREFIX : null;

    const selectedValue = useDropdownValue({ value: frequencyCapping }, msgIdPrefix);
    const options = useDropdownOptions(FREQUENCY_TYPES, msgIdPrefix);
    const changeHandler = useCallback(
        ({ value }) => {
            onFrequencyCappingChange(value);
        },
        [onFrequencyCappingChange]
    );
    return (
        <DropdownMenu
            id="frequency-types"
            options={options}
            selectedValueObject={selectedValue}
            onChange={changeHandler}
            dropdownWrapperClassName={styles['input']}
            styles={dropDownStyle}
        />
    );
};
